module.exports = __webpack_public_path__ + "static/img/bdc-trend-up.52492ec1.svg";